import {
  Autocomplete,
  Box,
  Button,
  Card,
  CardContent,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  getUserResidence,
  updateUserResidence,
  getDistricts,
} from "../../../../store/profile/actions";
import axios from "axios";
import { showError } from "../../../toastify";
import MaskedInput from "react-text-mask";
import moment from "moment";

export const ID_NUMBER_INPUT_PATTERN = [
  /[1-3]/,
  " ",
  /[1-2]/,
  /[0|9]/,
  /\d/,
  /\d/,
  " ",
  /[7-8]/,
  " ",
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  " ",
  /\d/,
  " ",
  /\d/,
  /\d/,
];

export const Identity = (props) => {
  const { application, loading, lookup, getDistricts, getUserResidence } =
    props;

  const [userResidence, setUserResidence] = useState({});

  const [sectors, setSectors] = useState([]);
  const [cells, setCells] = useState([]);
  const [villages, setVillages] = useState([]);

  const [district, setDistrict] = useState(null);
  const [sector, setSector] = useState(null);
  const [cell, setCell] = useState(null);
  const [village, setVillage] = useState(null);
  const [wait, setWait] = useState(false);
  const [nidLoading, setNidLoading] = useState(false);
  const [nidError, setNidError] = useState(false);

  const [formData, setFormData] = useState({
    idNumber: "",
    lastName: "",
    firstName: "",
    fatherNames: "",
    motherNames: "",
    placeOfBirth: "",
    phoneNumber: "",
    genderId: "",
    dateOfBirth: "",
    verified: false,
    profileImage: null,
  });
  useEffect(() => {
    if (
      application &&
      application.idNumber &&
      (application.idNumber.length === 21 || application.idNumber.length === 16)
    )
      verifyNationalID(application.idNumber);
  }, []);

  const verifyNationalID = async (idNumber) => {
    try {
      setNidLoading(true);

      const { data } = await axios.get(
        `/api/profile/user-identity/${(idNumber || "").replace(/\s/g, "")}`
      );

      setFormData({
        ...formData,
        idNumber: idNumber,
        lastName: data.lastName,
        firstName: data.firstName,
        fatherNames: data.fatherNames,
        motherNames: data.motherNames,
        placeOfBirth: data.placeOfBirth,
        genderId: data.genderId,
        dateOfBirth: data.dateOfBirth,
        phoneNumber: application.phoneNumber,
        verified: true,
      });

      getSectors(data.residence?.cell?.sector?.districtId);
      getCells(data.residence?.cell?.sectorId);
      getVillages(data.residence?.cellId);

      setVillage(data.residence || null);
      setCell(data.residence?.cell || null);
      setSector(data.residence?.cell?.sector || null);
      setDistrict(data.residence?.cell?.sector?.district || null);

      setNidError(false);
      setNidLoading(false);
    } catch (error) {
      setNidError(true);
      setNidLoading(false);
      showError(error);
    }
  };

  useEffect(() => {
    // setFormData({
    //   ...formData,
    //   idNumber: application.idNumber,
    //   lastName: application.lastName,
    //   firstName: application.firstName,
    //   fatherNames: application.fatherNames,
    //   motherNames: application.motherNames,
    //   placeOfBirth: application.placeOfBirth,
    //   phoneNumber: application.phoneNumber,
    //   genderId: application.genderId,
    //   dateOfBirth: application.dateOfBirth,
    //   verified: application.nidVerified,
    //   profileImage: application.profileImage,
    // });

    // if (!application.nidVerified) setNidError(true);

    // if ((application.idNumber || "").replace(/\s/g, "").length === 16)
    //   verifyNationalID(application.idNumber);

    if (!lookup.districts) getDistricts();
    getUserResidence(setUserResidence, application.id);
  }, []);

  useEffect(() => {
    if (!!userResidence) {
      if (!!userResidence?.cell?.sector?.districtId)
        getSectors(userResidence?.cell?.sector?.districtId);
      if (!!userResidence?.cell?.sectorId)
        getCells(userResidence?.cell?.sectorId);
      if (!!userResidence?.cellId) getVillages(userResidence?.cellId);

      setVillage(userResidence || null);
      setCell(userResidence?.cell || null);
      setSector(userResidence?.cell?.sector || null);
      setDistrict(userResidence?.cell?.sector?.district || null);
    }
  }, [userResidence]);

  useEffect(() => {
    if (!!district?.id) getSectors(district.id);
  }, [district]);

  useEffect(() => {
    if (!!sector?.id) getCells(sector.id);
  }, [sector]);

  useEffect(() => {
    if (!!cell?.id) getVillages(cell.id);
  }, [cell]);

  const getSectors = async (districtId) => {
    try {
      setWait(true);
      const { data } = await axios.get(`/api/lookup/sectors/` + districtId);
      setSectors(data);
      setWait(false);
    } catch (error) {
      setWait(false);
      showError(error);
    }
  };

  const getCells = async (sectorId) => {
    try {
      setWait(true);
      const { data } = await axios.get(`/api/lookup/cells/` + sectorId);
      setCells(data);
      setWait(false);
    } catch (error) {
      setWait(false);
      showError(error);
    }
  };

  const getVillages = async (cellId) => {
    try {
      setWait(true);
      const { data } = await axios.get(`/api/lookup/villages/` + cellId);
      setVillages(data);
      setWait(false);
    } catch (error) {
      setWait(false);
      showError(error);
    }
  };
  return (
    <>
      <Card className={`border rounded mb-3`} elevation={1}>
        {/* <Alert icon={false} severity="info"> */}

        {/* </Alert> */}

        <CardContent>
          <div className="container-fluid">
            <Typography
              variant="h6"
              className="text-blue mt-1 ml-1 text-uppercase"
            >
              Identity
            </Typography>

            <div className="row justify-content-center ">
              <div className="col-12">
                {/* <div className="card border-primary mb-3"> */}
                <div className="row align-items-center justify-content-start">
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    {!formData.verified && !nidLoading && !nidError && (
                      <span className="material-icons loaderIcon text-info">
                        help
                      </span>
                    )}

                    {nidLoading && (
                      <i
                        className="fas fa-spinner loaderIcon text-primary loader2"
                        style={{ fontSize: "22px" }}
                      ></i>
                    )}

                    {!nidLoading && !!nidError && (
                      <span className="loaderIcon text-danger d-flex align-items-center">
                        <span className="material-icons text-danger">
                          report_problem
                        </span>
                      </span>
                    )}

                    {formData.verified && !nidLoading && !nidError && (
                      <span className="loaderIcon text-success d-flex align-items-center">
                        <span className="material-icons text-success ">
                          verified
                        </span>
                      </span>
                    )}
                    <MaskedInput
                      mask={ID_NUMBER_INPUT_PATTERN}
                      className="form-control"
                      placeholder="Enter your NID Number"
                      guide={false}
                      value={formData.idNumber}
                      readOnly
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Last Name"
                      value={formData.lastName}
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="First Name"
                      value={formData.firstName}
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div>
                  {/* <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Father Name"
                      value={formData.fatherNames || ""}
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Mother Name"
                      value={formData.motherNames || ""}
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div> */}
                  {/* <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Place of Birth"
                      value={formData.placeOfBirth || ""}
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div> */}
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Gender"
                      value={formData.genderId === "M" ? "Male" : "Female"}
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Date of Birth"
                      value={
                        !!formData.dateOfBirth
                          ? moment(formData.dateOfBirth).format("ll")
                          : ""
                      }
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Email"
                      value={application.email}
                      size="small"
                      InputProps={{
                        readOnly: true,
                      }}
                      className="w-100"
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <TextField
                      label="Phone Number"
                      value={formData.phoneNumber || ""}
                      size="small"
                      className={`w-100`}
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </div>

                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <Autocomplete
                      size="small"
                      defaultValue={null}
                      value={district}
                      options={lookup.districts || []}
                      disabled
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, district) => {
                        setDistrict(district || null);
                        setSector(null);
                        setCell(null);
                        setVillage(null);

                        setSectors([]);
                        setCells([]);
                        setVillages([]);
                      }}
                      getOptionLabel={(option) => option.name || ""}
                      renderOption={(props, district) => (
                        <Box component="li" {...props} key={district.id}>
                          {district.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          style={{
                            height: "25px !important",
                            position: "relative",
                            borderRadius: "8px",
                            padding: "1px !important",
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                          {...params}
                          label="Residence district"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "name", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <Autocomplete
                      size="small"
                      defaultValue={null}
                      value={sector}
                      options={sectors}
                      disabled
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, sector) => {
                        setSector(sector || null);
                        setCell(null);
                        setVillage(null);

                        setCells([]);
                        setVillages([]);
                      }}
                      getOptionLabel={(option) => option.name || ""}
                      renderOption={(props, sector) => (
                        <Box component="li" {...props} key={sector.id}>
                          {sector.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          InputProps={{
                            readOnly: true,
                          }}
                          size="small"
                          style={{
                            height: "25px !important",
                            position: "relative",
                            borderRadius: "8px",
                            padding: "1px !important",
                          }}
                          {...params}
                          label="Residence sector"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "name", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <Autocomplete
                      size="small"
                      defaultValue={null}
                      value={cell || null}
                      options={cells}
                      disabled
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, cell) => {
                        setCell(cell || null);
                        setVillage(null);
                        setVillages([]);
                      }}
                      getOptionLabel={(option) => option.name || ""}
                      renderOption={(props, cell) => (
                        <Box component="li" {...props} key={cell.id}>
                          {cell.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          style={{
                            height: "25px !important",
                            position: "relative",
                            borderRadius: "8px",
                            padding: "1px !important",
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                          {...params}
                          label="Residence cell"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "name", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </div>
                  <div className="col-12 col-md-6 col-lg-4 mb-2 mt-2">
                    <Autocomplete
                      size="small"
                      defaultValue={null}
                      value={village || null}
                      options={villages}
                      disabled
                      isOptionEqualToValue={(option, value) =>
                        option.id === value.id
                      }
                      onChange={(event, village) => setVillage(village || null)}
                      getOptionLabel={(option) => option.name || ""}
                      renderOption={(props, village) => (
                        <Box component="li" {...props} key={village.id}>
                          {village.name}
                        </Box>
                      )}
                      renderInput={(params) => (
                        <TextField
                          size="small"
                          style={{
                            height: "25px !important",
                            position: "relative",
                            borderRadius: "8px",
                            padding: "1px !important",
                          }}
                          InputProps={{
                            readOnly: true,
                          }}
                          {...params}
                          label="Residence village"
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "name", // disable autocomplete and autofill
                          }}
                        />
                      )}
                    />
                  </div>
                </div>
                {/* </div> */}
              </div>
            </div>
          </div>
        </CardContent>
      </Card>
    </>
  );
};

const mapStateToProps = ({ loading, lookup }) => ({
  loading,
  lookup,
});

export default connect(mapStateToProps, {
  getUserResidence,
  updateUserResidence,
  getDistricts,
})(Identity);
